<template>
  <div class="app-wrapper">
    <Menu />
    <div class="main-container">
      <NavBar />
      <app-main class="app-main" />
    </div>
  </div>
</template>

<script setup>
import Menu from './components/Menu.vue'
import AppMain from './components/AppMain.vue'
import NavBar from './components/Navbar.vue'
</script>

<style lang="scss" scoped>
.app-wrapper {
  display: flex;
  flex-direction: row;
  height: 100%;
  overflow: hidden;
}

.main-container {
  display: flex;
  flex-direction: column;
  // padding: 0 30px 10px 40px;
  margin-left: 40px;
  // flex-grow: 1;
  overflow: hidden;
  flex: 1;
}
.app-main {
  margin-top: 16px;
  flex: 1;
}
</style>
